import { RoutingWrapper } from "@core";

export class ChronodriveRoutingWrapper extends RoutingWrapper {
  /**
   * @param {string} route to check
   * @returns true is host know the route
   */
  // eslint-disable-next-line no-unused-vars
  doesRouteExists(route) {
      throw new Error('You must implement \'doesRouteExists\' for this retailer');
  }

  /**
   * go to the given page 
   * @param {string} route  to go
   */
  // eslint-disable-next-line no-unused-vars
  navigate(route) {
    window.location.href = route;
  }


  /**
   * @optional
   * only for SPA action to do on navigation
   * this function purpose is to subscribe to routting event
   * and call a callBack then witch is designe to be @resolveRoute
   */
  // eslint-disable-next-line no-unused-vars
  onRoutingEvent(callBack) {
  }
}